<template>
	<!--#app为页面的入口-->
	<div id="app">
		<!--loading效果-->
		<div class="loading" v-show="loadingShow">
			<div class="loading_bg">
				<div class="loading_img img">
					<img src="./assets/icon_loading.png" alt="">
				</div>
			</div>
		</div>
		<!--全屏全透明的遮罩层。-->
		<div class="transparent_bg" v-show="bgTransparentShow" @touchmove.prevent></div>
		<!--全屏灰色半透明的遮罩层-->
		<div class="gray_bg" v-show="bgGrayShow" @touchmove.prevent></div>
		<!-- toast层 -->
		<div class="toast" :class="{toastShow:toastShowClass}" v-show="toastShow">{{toastText || "设备绑定失败"}}</div>
		<!--公共提示语弹框。如需其他额外的弹框和遮罩层，请自行添加。注意index的层级-->
		<div class="alert_box" v-show="alertBoxShow" @touchmove.prevent>
			<!--弹框标题-->
			<div class="alert_title" v-show="alertTitle">{{alertTitle}}</div>
			<!--弹框主体内容-->
			<div class="alert_content">{{alertContent}}</div>
			<div class="alert_button_group">
				<!--弹框的“取消”和“确定”按钮-->
				<div class="cancel" @click="alert_box_cancel" v-show="cancelText">{{cancelText}}</div>
				<div class="confirm" @click="alert_box_confirm">{{confirmText || "确定"}}</div>
			</div>
		</div>
		<router-view />
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from "vuex"

	export default {
		name: 'App',
		data() {
			return {}
		},
		computed: {
			...mapState([
				"bgTransparentShow",
				"bgGrayShow",
				"alertBoxShow",
				"alertTitle",
				"alertContent",
				"cancelText",
				"confirmText",
				"confirmStat",
				"loadingShow",
				"toastShow",
				"toastText",
				"toastShowClass"
			]),
		},
		methods: {
			...mapMutations([
				"alert_cancel",
			]),
			/*点击“取消”按钮执行的方法*/
			alert_box_cancel() {
				this.alert_cancel();
			},
			/*点击“确定”按钮执行的方法
			 * 说明：每次触发弹框时，请传stat参数，通常为“01”，如果点击“确定”按钮需要执行特定的回调，请传自定义的stat参数，然后在下边写相应的回调*/
			alert_box_confirm() {
				this.alert_cancel();
				if (this.confirmStat === "01") {
					return
				} else if (this.confirmStat === "back") {
					history.go(-1);
				} else if (this.confirmStat === "登录超时" || this.confirmStat === "异地登录" || this.confirmStat === "设备号异地校验失败") {
					this.callAppMethod({
						callName: "clearLoginInfo",
						parameters: "",
						callback: ""
					});
					this.callAppMethod({
						callName: "toLogin",
						parameters: "",
						callback: ""
					})
				}
			}
		}
	}
</script>

<style lang="less">
	#app {
		.toastShow{
			animation: showToast linear 2s forwards;
		}
		.flex_center {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;

		.gray_bg,
		.transparent_bg {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background: #000;
			opacity: .4;
			box-sizing: border-box;
			z-index: 500;
			overflow: hidden;
		}

		.transparent_bg {
			opacity: 0;
		}

		.toast {
			position: fixed;
			top: 35%;
			left: 150px;
			width: 450px;
			padding: 45px;
			text-align: center;
			margin-top: 200px;
			background: rgba(0, 0, 0, 0.6);
			font-size: 32px;
			color: #fefefe;
			line-height: 1;
			border-radius: 8px;
			transition: all 1s ease-in-out;

			.text {
				font-size: 32px;
				color: #fefefe;
				line-height: 1;
			}
		}

		.alert_box {
			position: fixed;
			top: 40%;
			left: 95px;
			width: 560px;
			height: auto;
			padding-top: 60px;
			background: #fff;
			border-radius: 20px;
			z-index: 501;

			.alert_title {
				width: 100%;
				height: 36px;
				max-height: 100%;
				font-size: 36px;
				font-weight: bold;
				.flex_center;
			}

			.alert_content {
				width: 100%;
				min-height: 30px;
				margin-top: 30px;
				padding: 0 32px;
				max-height: 100%;
				font-size: 30px;
				word-break: break-all;
				.flex_center;
			}

			.alert_button_group {
				width: 100%;
				height: 90px;
				margin-top: 50px;
				border-top: 1px solid #e5e5e5;
				/*no*/
				.flex_center;

				.cancel,
				.confirm {
					.flex_center;
					flex-grow: 1;
					height: 100%;
					max-height: 100%;
					font-size: 32px;
				}

				.cancel {}

				.confirm {
					color: #f72539;
					border-left: 1px solid #e5e5e5;
					/*no*/
					;
				}
			}
		}

		.loading {
			position: fixed;
			top: 50%;
			left: 50%;
			width: 80px;
			height: 80px;
			-webkit-transform: translate(-50%, -50%);
			-moz-transform: translate(-50%, -50%);
			-ms-transform: translate(-50%, -50%);
			-o-transform: translate(-50%, -50%);
			transform: translate(-50%, -50%);
			transform-origin: center;

			.loading_bg {
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, .1);
				.flex_center;

				.loading_img {
					width: 40px;
					height: 40px;
					-webkit-animation: loading 2s steps(9, end) infinite;
					-o-animation: loading 2s steps(9, end) infinite;
					animation: loading 2s steps(9, end) infinite;
				}
			}
		}
	}

	@keyframes loading {
		0% {
			-webkit-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@keyframes showToast{
		0%{
			display:none;
			opacity:0;
		}
		25%{
			display:block;
			opacity:1;
		}
		50%{
			display:block;
			opacity:1;
		}
		75%{
			display:block;
			opacity:0.5;
		}
		100%{
			display:none;
			opacity:0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue